import career from './career';

export default career;
